import { Link } from "react-router-dom";
import styles from "./Hero.module.css";

const candidates = [
  {
    initials: "AK",
    av: "av1",
    name: "Amara Kone",
    role: "Senior Engineer · Lagos, NG · 7 yrs",
    score: "96%",
  },
  {
    initials: "TO",
    av: "av2",
    name: "Tunde Okafor",
    role: "Full-stack · Accra, GH · 5 yrs",
    score: "93%",
  },
  {
    initials: "NM",
    av: "av3",
    name: "Naledi Mokoena",
    role: "Backend · Cape Town, ZA · 6 yrs",
    score: "91%",
  },
  {
    initials: "CA",
    av: "av4",
    name: "Chiamaka Adebayo",
    role: "Data Engineer · Nairobi, KE · 4 yrs",
    score: "88%",
  },
];

const trustLogos = [
  "◆ Northwind",
  "▲ Apex Labs",
  "● Kima",
  "⬢ Quantra",
  "✦ Sahel",
  "◇ Helix",
];

export default function Hero() {
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.heroGrid}>
          {/* Left — text */}
          <div className={styles.heroText}>
            <div className={styles.heroEyebrow}>
              <span className={styles.dot} />
              Africa's verified talent network
            </div>

            <h1 className={styles.h1}>
              Hire smarter.{" "}
              <span className={styles.highlight}>Not harder.</span>
            </h1>

            <p className={styles.heroSub}>
              Awasource connects businesses with verified talent across
              Africa, with role-specific assessments that show who can do the
              job.
            </p>

            <div className={styles.heroCta}>
              <Link
                to="/register?tab=client"
                className={`${styles.btn} ${styles.btnPrimary} ${styles.btnLg}`}
              >
                Get Started →
              </Link>
              <Link
                to="/talents"
                className={`${styles.btn} ${styles.btnSecondary} ${styles.btnLg}`}
              >
                Find Talent
              </Link>
            </div>

            <div className={styles.heroMeta}>
              <div className={styles.heroMetaItem}>
                <span className={styles.check}>✓</span> Verified profiles only
              </div>
              <div className={styles.heroMetaItem}>
                <span className={styles.check}>✓</span> One free trial match
              </div>
            </div>
          </div>

          {/* Right — dashboard visual */}
          <div className={styles.heroVisual}>
            {/* Float card 1 */}
            <div className={`${styles.floatCard} ${styles.fc1}`}>
              <div className={`${styles.floatIcon} ${styles.floatIconSuccess}`}>
                ✓
              </div>
              <div className={styles.floatText}>
                <strong>96% Match</strong>
                Verified talent
              </div>
            </div>

            {/* Dashboard */}
            <div className={styles.dashboard}>
              <div className={styles.dashboardHeader}>
                <span className={`${styles.dotR} ${styles.red}`} />
                <span className={`${styles.dotR} ${styles.yellow}`} />
                <span className={`${styles.dotR} ${styles.green}`} />
                <span className={styles.urlBar}>
                  app.awasource.com / talent
                </span>
              </div>
              <div className={styles.dashboardBody}>
                <div className={styles.dashHeader}>
                  <div className={styles.dashTitle}>
                    Top matches for Senior Engineer
                  </div>
                  <span className={styles.dashPill}>142 verified</span>
                </div>

                {candidates.map((c) => (
                  <div key={c.initials} className={styles.candidate}>
                    <div className={`${styles.avatar} ${styles[c.av]}`}>
                      {c.initials}
                    </div>
                    <div className={styles.candInfo}>
                      <span className={styles.candName}>
                        {c.name} <span className={styles.verify}>✓</span>
                      </span>
                      <span className={styles.candRole}>{c.role}</span>
                    </div>
                    <div>
                      <div className={styles.candScore}>{c.score}</div>
                      <div className={styles.candScoreLabel}>match</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Float card 2 */}
            <div className={`${styles.floatCard} ${styles.fc2}`}>
              <div className={styles.floatIcon}>⚡</div>
              <div className={styles.floatText}>
                <strong>14 days</strong>
                Avg. time-to-hire
              </div>
            </div>
          </div>
        </div>

        {/* Trust bar */}
        {/* <div className={styles.trustBar}>
          <div className={styles.trustLabel}>
            Trusted by teams hiring across Africa
          </div>
          <div className={styles.trustLogos}>
            {trustLogos.map((logo) => (
              <div key={logo} className={styles.trustLogo}>
                {logo}
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  );
}
